export default __webpack_public_path__ + "static/media/0166.4f971af0.png";